var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-textarea',{attrs:{"clearable":"","clear-icon":_vm.icons.mdiCloseCircleOutline,"label":"Text","value":"This is clearable text.","hide-details":""}})}
var staticRenderFns = []

export { render, staticRenderFns }